import { AccountDisplay, AccountInvoiceDisplay } from '../../components/account'
import { AddressDisplay } from '../../pages/address'
import { ApplicationRoute } from '../../../routes/applicationRoute'
import { AppsDisplay } from '../../pages/apps'
import { ArtistsDisplay } from '../../pages/artists'
import { AssetDownloadDisplay } from '../../pages/asset_download'
import { ComparisonDisplay } from '../../pages/comparison'
import { CookiesDisplay } from '../../pages/cookies'
import { ExclusivesDisplay } from '../../pages/exclusives'
import { ForgotPasswordDisplay } from '../../components/forgot_password_display'
import { FreePackCampaignDisplay } from '../../components/free_pack_campaign'
import { GlobalDisplay } from '../../pages/global'
import { GuideDisplay } from '../../pages/guide'
import { HomeDisplay, HomeOnboardingDisplay } from '../../pages/home'
import {
  homePathSelector,
  loggedInSelector,
  onboardingSelector,
} from '../../selectors/users'
import { HotBoxDisplay } from '../../pages/hot_box'
import { IntegrationsDisplay } from '../../pages/integrations'
import { LOCALIZED_ROUTES } from '../../../locale_data/config'
import { LocalizedRoute } from '../../../routes/localizedRoutes'
import { LoginDisplay } from '../../components/login_display'
import { MarketingDisplay } from '../../pages/marketing'
import { MusicSubmissionDisplay } from '../../components/music_submission'
import { NewReleasesDisplay } from '../../pages/new_releases'
import { NewsDisplay } from '../../pages/news'
import { PaymentConfirmationDisplay } from '../../components/payment_confirmation'
import { PaymentDetailsDisplay } from '../../components/payment_details'
import { PaymentDisplay } from '../../pages/payment'
import { PlaylistsDisplay } from '../../pages/playlists'
import { PostRoutesDisplay } from '../../pages/posts'
import { Redirect, Switch } from 'react-router-dom'
import { RemixersDisplay } from '../../pages/remixers'
import { RemixerSearchDisplay } from '../../pages/remixer_search'
import { ResetPasswordDisplay } from '../../components/reset_password_display'
import { ReturnPolicyDisplay } from '../../pages/return_policy'
import { SearchOverviewDisplay } from '../../components/search_overview'
import { SearchSongsDisplay } from '../../components/search_songs'
import { SongDetailsDisplay } from '../../components/song_details'
import { StatisticsDisplay } from '../../pages/statistics'
import { SubscriptionDisplay } from '../../pages/subscription'
import { SunsetDisplay } from '../../pages/sunset'
import { TagsDisplay } from '../../pages/tags'
import { TagSearchDisplay } from '../../pages/tag_search'
import { TopDownloadsDisplay } from '../../pages/top_downloads'
import { UpdatedSongsDisplay } from '../../pages/updated_songs'
import { useSelector } from 'react-redux'
import { WelcomeBackCampaignDisplay } from '../../components/welcome-back-campaign'
import React from 'react'

// eslint-disable-next-line react/display-name
export default () => {
  const isLoggedIn = useSelector(loggedInSelector)
  const homePath = useSelector(homePathSelector)
  const hasOnboarding = useSelector(onboardingSelector)

  // SUNSET
  const sunsetModeStatus = useSelector(state => state.sunset.sunsetModeStatus)
  const preSunsetModeStatus = useSelector(
    state => state.sunset.preSunsetModeStatus
  )
  const redirectToHome = !isLoggedIn && !sunsetModeStatus && preSunsetModeStatus

  return (
    <Switch>
      <Redirect
        from="/digital/(.*?)(---*):trackId(\d+)(.*)"
        to="/records/:trackId"
      />
      <Redirect from="/djcity-downloader-readme" to="/guide" />
      <Redirect from="/trends" to="/playlists" />
      <Redirect from="/charts" to="/monthly-charts" />
      <ApplicationRoute
        path="/faq"
        render={() => {
          window.location = 'https://support.djcity.com/hc/en-us'
          return null
        }}
      />
      <Redirect exact from="/(about|aboutus)" to={homePath} />

      <ApplicationRoute
        exact
        path="/beatport"
        render={props => <SunsetDisplay {...props} isLoggedIn={isLoggedIn} />}
      />

      <ApplicationRoute
        exact
        path="/"
        render={
          isLoggedIn || redirectToHome
            ? () => <Redirect to="/home" />
            : MarketingDisplay
        }
      />

      <ApplicationRoute
        exact
        path="/home"
        render={hasOnboarding ? HomeOnboardingDisplay : HomeDisplay}
      />
      <ApplicationRoute
        exact
        path="/new-releases"
        render={NewReleasesDisplay}
      />
      <ApplicationRoute exact path="/most-popular" render={HotBoxDisplay} />
      <ApplicationRoute exact path="/exclusives" render={ExclusivesDisplay} />
      <ApplicationRoute
        exact
        path="/(playlist|playlists)/:groupSlug?/:listSlug?"
        render={PlaylistsDisplay}
      />
      <ApplicationRoute exact path="/genre/:id" render={TagsDisplay} />
      <ApplicationRoute exact path="/genres" render={TagSearchDisplay} />
      <ApplicationRoute exact path="/remixers" render={RemixerSearchDisplay} />
      <ApplicationRoute exact path="/global" render={GlobalDisplay} />
      <ApplicationRoute
        exact
        path="/(remixer|remixers)/:slug"
        render={RemixersDisplay}
      />
      <ApplicationRoute
        exact
        path="/(artist|artists)"
        render={ArtistsDisplay}
      />
      <ApplicationRoute
        exact
        path="/(artist|artists)/*"
        render={ArtistsDisplay}
      />
      <ApplicationRoute
        exact
        path="/monthly-charts"
        render={TopDownloadsDisplay}
      />
      <ApplicationRoute exact path="/records/*" render={SongDetailsDisplay} />
      <ApplicationRoute exact path="/search" render={SearchSongsDisplay} />
      <ApplicationRoute
        exact
        path="/search-overview"
        render={SearchOverviewDisplay}
      />
      <ApplicationRoute exact path="/apps" render={AppsDisplay} />
      <ApplicationRoute
        exact
        path="/(about|aboutus)"
        render={MarketingDisplay}
      />
      <ApplicationRoute
        exact
        path="/offer/:offerName"
        render={MarketingDisplay}
      />
      <ApplicationRoute exact path="/guide" render={GuideDisplay} />
      <ApplicationRoute exact path="/cookies" render={CookiesDisplay} />
      <ApplicationRoute
        exact
        path="/return-policy"
        render={ReturnPolicyDisplay}
      />
      <ApplicationRoute exact path="/news" render={NewsDisplay} />
      <LocalizedRoute
        path={`/:locale(${Object.keys(LOCALIZED_ROUTES).join('|')})`}
        to="/"
      />
      <ApplicationRoute
        exact
        path="/payment-details"
        render={PaymentDetailsDisplay}
        requireAuth
      />
      <ApplicationRoute
        exact
        path="/payment-confirmation"
        render={PaymentConfirmationDisplay}
        requireAuth
      />
      <ApplicationRoute
        exact
        path="/payment-update"
        render={PaymentDisplay}
        requireAuth
      />
      <ApplicationRoute
        exact
        path="/update-address"
        render={AddressDisplay}
        requireAuth
      />
      <ApplicationRoute
        exact
        path="/update-password"
        render={ResetPasswordDisplay}
      />
      <ApplicationRoute
        exact
        path="/forgot-password"
        render={ForgotPasswordDisplay}
      />
      <ApplicationRoute exact path="/login" render={LoginDisplay} />
      <ApplicationRoute
        exact
        path="/free-download-pack"
        render={FreePackCampaignDisplay}
      />
      <ApplicationRoute exact path="/comparison" render={ComparisonDisplay} />
      <ApplicationRoute
        exact
        path="/integrations"
        render={IntegrationsDisplay}
      />
      <ApplicationRoute
        exact
        path="/asset-download"
        render={AssetDownloadDisplay}
        requireAuth
      />
      <ApplicationRoute
        exact
        path="/welcome-back"
        render={WelcomeBackCampaignDisplay}
      />
      <ApplicationRoute
        exact
        path="/track-updates"
        render={UpdatedSongsDisplay}
      />
      <ApplicationRoute
        component={AccountInvoiceDisplay}
        exact
        path="/account/billing/invoices/:id"
        requireAuth
      />
      <ApplicationRoute
        exact
        path="/account/change-subscription"
        render={SubscriptionDisplay}
        requireAuth
      />
      <ApplicationRoute path="/account" render={AccountDisplay} requireAuth />
      <ApplicationRoute
        exact
        path="/statistics/:guid"
        render={StatisticsDisplay}
      />
      <ApplicationRoute path="/submit-music" render={MusicSubmissionDisplay} />
      <ApplicationRoute path="*" render={PostRoutesDisplay} />
    </Switch>
  )
}
